import React from 'react';
import _get from 'lodash/get';
import { Typography, makeStyles } from '@material-ui/core';
import { CourseCommentQuestion } from './CourseCommentQuestion';
import { CoursePreviousReflection } from './CoursePreviousReflection';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: props => (props.small ? theme.spacing(2) : 30),
    borderRadius: 8,
    border: '1px solid #E0E0E0',

    '&:not(&:first-child)': {
      marginTop: 20,
    },
  },
  divider: {
    width: '100%',
    height: 1,
    border: 'none',
    margin: '20px 0px',
    backgroundColor: '#E0E0E0',
  },
  title: {
    fontWeight: 600,
    margin: '0px !important',
  },
  reflectionsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
  },
}));

export const CourseReflectionQuestion = ({
  answers,
  question,
  onAnswerChange,
  coursesSiteCopy,
  small,
}) => {
  const classes = useStyles({ small });

  const hasPrevAnswers = !!_get(answers, [question.name], []).length;
  const saveLabel = _get(coursesSiteCopy, 'pageCopy.save');

  return (
    <section className={classes.root} id={question.name}>
      <CourseCommentQuestion
        key={question.name}
        answer={_get(answers, [question.name, '0', 'answer'])}
        saveAnswer={onAnswerChange}
        saveLabel={saveLabel}
        {...question}
      />
      {hasPrevAnswers && (
        <div>
          <hr className={classes.divider} />
          <Typography color="textPrimary" className={classes.title}>
            {_get(coursesSiteCopy, 'pageCopy.previousReflection')}
          </Typography>
          <div className={classes.reflectionsContainer}>
            {answers[question.name].slice(0).map(ans => (
              <CoursePreviousReflection
                key={ans.id}
                answer={ans}
                question={question}
                onAnswerChange={onAnswerChange}
                coursesSiteCopy={coursesSiteCopy}
                small={small}
              />
            ))}
          </div>
        </div>
      )}
    </section>
  );
};
